// react-oidc-context configuration. Cognito Hosted UI is OIDC-compliant; we
// use the user pool's well-known issuer as the authority and the SPA app
// client as the client. Tokens are stored in sessionStorage by default.

import type { AuthProviderProps } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import { config } from "./config";

export const oidcConfig: AuthProviderProps = {
  authority: config.cognitoAuthority,
  client_id: config.cognitoClientId,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: "code",
  scope: "openid email profile",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Cognito's end_session endpoint signature differs from the OIDC spec; we
  // build the logout URL manually in the sign-out handler.
  automaticSilentRenew: true,
  onSigninCallback: () => {
    // Clean the OAuth response params out of the URL.
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export function buildCognitoLogoutUrl(): string {
  const url = new URL(`https://${config.cognitoDomain}/logout`);
  url.searchParams.set("client_id", config.cognitoClientId);
  url.searchParams.set("logout_uri", `${window.location.origin}/`);
  return url.toString();
}
